import { PageHead, Card } from "../components/kit";
import { Icon } from "../components/Icon";

/* Temporary section body while each operator section is ported. */
export function Stub({ label }: { label: string }) {
  return (
    <div className="page">
      <PageHead title={label} sub={`The ${label} section is being built in this phase.`} />
      <Card title="Coming up" icon="hammer">
        <div className="att" style={{ padding: "14px 4px" }}>
          <span className="att-ic neutral"><Icon name="wrench" size={16} /></span>
          <div style={{ flex: 1 }}>
            <div className="att-t">{label}</div>
            <div className="att-d">Ported from the God Console prototype next.</div>
          </div>
        </div>
      </Card>
    </div>
  );
}
